/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3ContextualTargeting } from '../models/V3ContextualTargeting';
import { V3DealConfig } from '../models/V3DealConfig';
import { V3RTBOrderLineUpdateStatus } from '../models/V3RTBOrderLineUpdateStatus';
import { HttpFile } from '../http/http';

export class V3RTBOrderLine {
    'id'?: string;
    'externalId'?: string;
    'name'?: string;
    'campaignId'?: string;
    'cpm'?: number;
    'priority'?: number;
    'status'?: string;
    'currency'?: string;
    'pacingStrategy'?: string;
    'budget'?: number;
    'dailyBudget'?: number;
    'dailyBudgetType'?: string;
    'underspendCatchUp'?: boolean;
    'startTime'?: string;
    'endTime'?: string;
    'targetGeo'?: Array<string>;
    'targetDevice'?: Array<string>;
    'targetDeviceIds'?: Array<string>;
    'targetIps'?: Array<string>;
    'targetSegmentIds'?: Array<string>;
    'excludedSegmentIds'?: Array<string>;
    'targetRegions'?: Array<string>;
    'targetCities'?: Array<string>;
    'targetDmas'?: Array<string>;
    'targetZips'?: Array<string>;
    'targetRadius'?: string;
    'polygons'?: Array<string>;
    'excludeGeo'?: Array<string>;
    'excludeRegions'?: Array<string>;
    'excludeCities'?: Array<string>;
    'excludeDmas'?: Array<string>;
    'excludeZips'?: Array<string>;
    'targetCtv'?: boolean;
    'ctvOnly'?: boolean;
    'ctvDeviceTypes'?: Array<number>;
    'ctvBidMultiplier'?: number;
    'targetAudioOnly'?: boolean;
    'targetAudioFeeds'?: Array<number>;
    'targetAudioGenres'?: Array<string>;
    'audioBidMultiplier'?: number;
    'targetBrowsers'?: Array<string>;
    'targetOs'?: Array<string>;
    'targetDeviceVendors'?: Array<string>;
    'excludeBots'?: boolean;
    'targetLanguages'?: Array<string>;
    'targetConnectionTypes'?: Array<number>;
    'minOsVersion'?: string;
    'maxOsVersion'?: string;
    'sensitiveExclusions'?: Array<string>;
    'excludedNetworkIds'?: Array<string>;
    'podEnabled'?: boolean;
    'podSlotPreference'?: number;
    'podSlotPremium'?: number;
    'podCompetitiveSeparation'?: boolean;
    'podMaxFillPerPod'?: number;
    'frequencyCap'?: number;
    'frequencyWindow'?: number;
    'lifetimeFreqCap'?: number;
    'dailyImpressionCap'?: string;
    'lifetimeImpressionCap'?: string;
    'deals'?: Array<V3DealConfig>;
    'vcrEnabled'?: boolean;
    'vcrTarget'?: number;
    'vcrMinBid'?: number;
    'vcrMaxBid'?: number;
    'bidShading'?: boolean;
    'shadingFactor'?: number;
    'bidModifiers'?: { [key: string]: number; };
    'bidFloor'?: number;
    'bidCeiling'?: number;
    'minCpm'?: number;
    'maxCpm'?: number;
    'daypartTimezone'?: string;
    'daypartSchedule'?: Array<number>;
    'domainWhitelist'?: Array<string>;
    'domainBlacklist'?: Array<string>;
    'iabCategories'?: Array<string>;
    'iabExclusions'?: Array<string>;
    'honorDoNotTrack'?: boolean;
    'requireConsent'?: boolean;
    'viewabilityEnabled'?: boolean;
    'minViewabilityRate'?: number;
    'updateStatus'?: V3RTBOrderLineUpdateStatus;
    'internalCampaignId'?: string;
    'clickUrl'?: string;
    'hourlyPacing'?: Array<number>;
    'dailyFrontload'?: number;
    'biddingStrategy'?: string;
    'targetCpa'?: number;
    'targetRoas'?: number;
    'optimizerEnabled'?: boolean;
    'optimizationGoal'?: string;
    'goalMode'?: string;
    'contextualCategories'?: V3ContextualTargeting;
    'contextualKeywords'?: V3ContextualTargeting;
    /**
    * APP INVENTORY TARGETING (PLADV-2705 / HMDL-161) — restrict or block in-app inventory by bundle id. Heimdall defaults targetApps=true when unset; blacklist wins over whitelist for a given bundle. optional (field presence) so we can distinguish \"disable app inventory\" (false) from \"unset\" (omit → Heimdall default true). Heimdall's own client only sends this field when it is false.
    */
    'targetApps'?: boolean;
    'appBundleWhitelist'?: Array<string>;
    'appBundleBlacklist'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignId",
            "baseName": "campaignId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cpm",
            "baseName": "cpm",
            "type": "number",
            "format": "double"
        },
        {
            "name": "priority",
            "baseName": "priority",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "currency",
            "baseName": "currency",
            "type": "string",
            "format": ""
        },
        {
            "name": "pacingStrategy",
            "baseName": "pacingStrategy",
            "type": "string",
            "format": ""
        },
        {
            "name": "budget",
            "baseName": "budget",
            "type": "number",
            "format": "double"
        },
        {
            "name": "dailyBudget",
            "baseName": "dailyBudget",
            "type": "number",
            "format": "double"
        },
        {
            "name": "dailyBudgetType",
            "baseName": "dailyBudgetType",
            "type": "string",
            "format": ""
        },
        {
            "name": "underspendCatchUp",
            "baseName": "underspendCatchUp",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetGeo",
            "baseName": "targetGeo",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetDevice",
            "baseName": "targetDevice",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetDeviceIds",
            "baseName": "targetDeviceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetIps",
            "baseName": "targetIps",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetSegmentIds",
            "baseName": "targetSegmentIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludedSegmentIds",
            "baseName": "excludedSegmentIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetRegions",
            "baseName": "targetRegions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetCities",
            "baseName": "targetCities",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetDmas",
            "baseName": "targetDmas",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetZips",
            "baseName": "targetZips",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetRadius",
            "baseName": "targetRadius",
            "type": "string",
            "format": ""
        },
        {
            "name": "polygons",
            "baseName": "polygons",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludeGeo",
            "baseName": "excludeGeo",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludeRegions",
            "baseName": "excludeRegions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludeCities",
            "baseName": "excludeCities",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludeDmas",
            "baseName": "excludeDmas",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludeZips",
            "baseName": "excludeZips",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetCtv",
            "baseName": "targetCtv",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ctvOnly",
            "baseName": "ctvOnly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ctvDeviceTypes",
            "baseName": "ctvDeviceTypes",
            "type": "Array<number>",
            "format": "int32"
        },
        {
            "name": "ctvBidMultiplier",
            "baseName": "ctvBidMultiplier",
            "type": "number",
            "format": "double"
        },
        {
            "name": "targetAudioOnly",
            "baseName": "targetAudioOnly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "targetAudioFeeds",
            "baseName": "targetAudioFeeds",
            "type": "Array<number>",
            "format": "int32"
        },
        {
            "name": "targetAudioGenres",
            "baseName": "targetAudioGenres",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "audioBidMultiplier",
            "baseName": "audioBidMultiplier",
            "type": "number",
            "format": "double"
        },
        {
            "name": "targetBrowsers",
            "baseName": "targetBrowsers",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetOs",
            "baseName": "targetOs",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetDeviceVendors",
            "baseName": "targetDeviceVendors",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludeBots",
            "baseName": "excludeBots",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "targetLanguages",
            "baseName": "targetLanguages",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetConnectionTypes",
            "baseName": "targetConnectionTypes",
            "type": "Array<number>",
            "format": "int32"
        },
        {
            "name": "minOsVersion",
            "baseName": "minOsVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "maxOsVersion",
            "baseName": "maxOsVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "sensitiveExclusions",
            "baseName": "sensitiveExclusions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludedNetworkIds",
            "baseName": "excludedNetworkIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "podEnabled",
            "baseName": "podEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "podSlotPreference",
            "baseName": "podSlotPreference",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "podSlotPremium",
            "baseName": "podSlotPremium",
            "type": "number",
            "format": "double"
        },
        {
            "name": "podCompetitiveSeparation",
            "baseName": "podCompetitiveSeparation",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "podMaxFillPerPod",
            "baseName": "podMaxFillPerPod",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "frequencyCap",
            "baseName": "frequencyCap",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "frequencyWindow",
            "baseName": "frequencyWindow",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "lifetimeFreqCap",
            "baseName": "lifetimeFreqCap",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "dailyImpressionCap",
            "baseName": "dailyImpressionCap",
            "type": "string",
            "format": "int64"
        },
        {
            "name": "lifetimeImpressionCap",
            "baseName": "lifetimeImpressionCap",
            "type": "string",
            "format": "int64"
        },
        {
            "name": "deals",
            "baseName": "deals",
            "type": "Array<V3DealConfig>",
            "format": ""
        },
        {
            "name": "vcrEnabled",
            "baseName": "vcrEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "vcrTarget",
            "baseName": "vcrTarget",
            "type": "number",
            "format": "double"
        },
        {
            "name": "vcrMinBid",
            "baseName": "vcrMinBid",
            "type": "number",
            "format": "double"
        },
        {
            "name": "vcrMaxBid",
            "baseName": "vcrMaxBid",
            "type": "number",
            "format": "double"
        },
        {
            "name": "bidShading",
            "baseName": "bidShading",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "shadingFactor",
            "baseName": "shadingFactor",
            "type": "number",
            "format": "double"
        },
        {
            "name": "bidModifiers",
            "baseName": "bidModifiers",
            "type": "{ [key: string]: number; }",
            "format": "double"
        },
        {
            "name": "bidFloor",
            "baseName": "bidFloor",
            "type": "number",
            "format": "double"
        },
        {
            "name": "bidCeiling",
            "baseName": "bidCeiling",
            "type": "number",
            "format": "double"
        },
        {
            "name": "minCpm",
            "baseName": "minCpm",
            "type": "number",
            "format": "double"
        },
        {
            "name": "maxCpm",
            "baseName": "maxCpm",
            "type": "number",
            "format": "double"
        },
        {
            "name": "daypartTimezone",
            "baseName": "daypartTimezone",
            "type": "string",
            "format": ""
        },
        {
            "name": "daypartSchedule",
            "baseName": "daypartSchedule",
            "type": "Array<number>",
            "format": "int32"
        },
        {
            "name": "domainWhitelist",
            "baseName": "domainWhitelist",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "domainBlacklist",
            "baseName": "domainBlacklist",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "iabCategories",
            "baseName": "iabCategories",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "iabExclusions",
            "baseName": "iabExclusions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "honorDoNotTrack",
            "baseName": "honorDoNotTrack",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "requireConsent",
            "baseName": "requireConsent",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "viewabilityEnabled",
            "baseName": "viewabilityEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "minViewabilityRate",
            "baseName": "minViewabilityRate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "updateStatus",
            "baseName": "updateStatus",
            "type": "V3RTBOrderLineUpdateStatus",
            "format": ""
        },
        {
            "name": "internalCampaignId",
            "baseName": "internalCampaignId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clickUrl",
            "baseName": "clickUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "hourlyPacing",
            "baseName": "hourlyPacing",
            "type": "Array<number>",
            "format": "double"
        },
        {
            "name": "dailyFrontload",
            "baseName": "dailyFrontload",
            "type": "number",
            "format": "double"
        },
        {
            "name": "biddingStrategy",
            "baseName": "biddingStrategy",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetCpa",
            "baseName": "targetCpa",
            "type": "number",
            "format": "double"
        },
        {
            "name": "targetRoas",
            "baseName": "targetRoas",
            "type": "number",
            "format": "double"
        },
        {
            "name": "optimizerEnabled",
            "baseName": "optimizerEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "optimizationGoal",
            "baseName": "optimizationGoal",
            "type": "string",
            "format": ""
        },
        {
            "name": "goalMode",
            "baseName": "goalMode",
            "type": "string",
            "format": ""
        },
        {
            "name": "contextualCategories",
            "baseName": "contextualCategories",
            "type": "V3ContextualTargeting",
            "format": ""
        },
        {
            "name": "contextualKeywords",
            "baseName": "contextualKeywords",
            "type": "V3ContextualTargeting",
            "format": ""
        },
        {
            "name": "targetApps",
            "baseName": "targetApps",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "appBundleWhitelist",
            "baseName": "appBundleWhitelist",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "appBundleBlacklist",
            "baseName": "appBundleBlacklist",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3RTBOrderLine.attributeTypeMap;
    }

    public constructor() {
    }
}

